<template>
  <div class="stat-wrap">
    <div class="header">
      <div class="header-l">
        <span class="title">网站访问数据统计</span>
      </div>
      <div class="header-r">
        <span class="desc">访问时间</span>
        <el-date-picker
          style="width: 240px;"
          v-model="statvalue"
          value-format="YYYY-MM-DD"
          type="daterange"
          range-separator="To"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        />
      </div>
    </div>
    <div class="subheader">
      <div class="subheader-l"><label>总数</label><span>{{total || '-'}}</span></div>
      <div class="subheader-r">
        <el-select v-model="statselect1" multiple collapse-tags placeholder="请选择" style="width: 156px">
          <el-option v-for="item in statselect1Options" :disabled="statselect1.length == 1 && statselect1[0] == item.value" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-select v-model="statselect2" placeholder="请选择" style="width: 156px">
          <el-option v-for="item in statselect2Options" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </div>
    </div>
    <div class="stat-inner-wrap" id="statVisitLog"></div>
  </div>
</template>

<script setup>
  import { onMounted, ref, watch } from 'vue'
  import * as echarts from 'echarts'
  import moment from 'moment'
  import * as Request from "@/assets/request";
  import * as Utils from "@/assets/utils";

  const total = ref(0)

  const statvalue = ref([moment().add(-30, 'day').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')])
  const statselect1 = ref([1, 2, 3, 4, 5, 6])
  const statselect1Options = ref([
    { label: '首页', value: 1 },
    { label: '海运跟踪', value: 2 },
    { label: '工作台', value: 3 },
    { label: '港口大全', value: 4 },
    { label: '集装箱尺寸', value: 5 },
    { label: 'HS CODE', value: 6 },
  ])
  const statselect2 = ref(1)
  const statselect2Options = ref([
    { label: '独立访客', value: 1 },
    { label: '独立ip', value: 2 },
    { label: '访问量PV', value: 3 },
  ])
  const initStat = async () => {
    const result = await Request.post({
      url: '/back/stat/getVisitLog',
      data: {
        dateRange: statvalue.value,
        visitTypes: statselect1.value,
        statType: statselect2.value,
      }
    })
    if(result?.data?.count) {
      total.value = Utils.format_with_substring(result?.data?.count)
    }
    
    const option = {
      xAxis: {
        type: 'category',
        data: []
      },
      yAxis: {
        type: 'value'
      },
      tooltip: {
        trigger: 'axis'
      },
      series: [],
      grid: {
        bottom: '10%',
      }
    };
    const dates = []
    const seriesMap = {}
    if(result?.data?.dates?.length > 0) {
      result?.data?.dates.map(item => {
        dates.push(item.date)
        if(item.items?.length > 0) {
          item.items.map(itm => {
            seriesMap[`${itm.typeName}`] = seriesMap[`${itm.typeName}`] || []
            seriesMap[`${itm.typeName}`].push(itm.count)
          })
        }
      })
    }
    const series = Object.keys(seriesMap).map(name => ({ 
      name,
      // stack: 'Total',
      type: 'line', 
      data: seriesMap[name] 
    }))
    option.xAxis.data = [...dates]
    option.series = [...series]

    echarts.init(document.getElementById('statVisitLog')).setOption({...option}, true)
  }
  onMounted(() => {
    initStat()
  })
  watch(() => [ statvalue.value, statselect1.value, statselect2.value ], () => {
    initStat()
  }, { deep: true })
</script>

<style scoped lang="less">
@import "index.less";
</style>
